import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import T from '../../i18n/i18n';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin: 0 0 10px;
    min-width: 70px;
    cursor: pointer;
`;

const Icon = styled.div`
    width: 15px;
    height: 25px;
    margin-right: 5px;
    position: relative;

    &:before {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        content: '\\F06D0';
        font-family: "Material Design Icons";
        font-size: 18px;
    }
`;

const Value = styled.div`
    line-height: 25px;
    color: #fff;
    font-size: 14px;
    margin-top: 1px;

    ${Container}:hover & {
        font-weight: 600;
        text-decoration: underline;
    }
`;


export default ({value, onChange}) => {
    const [visibility, setVisibility] = useState('F');

    const getLabel = () => {
        switch (visibility) {
            case 'F':
                return 'profileform.visibility-friends';
            case 'P':
                return 'profileform.visibility-public';
            default:
                return 'profileform.visibility-hide';
        }
    };

    const handleClick = () => {
        let newValue = '';
        switch (visibility) {
            case 'F':
                newValue ="P"; break;
            case 'P':
                newValue = "H"; break;
            default:
                newValue = "F"; break;
        }

        setVisibility(newValue);

        if(onChange && typeof onChange === 'function') {
            onChange(newValue);
        }
    }

    useEffect(() => {
        setVisibility(value);
    }, [value]);

    return <Container onClick={handleClick}>
        <Icon/>
        <Value>
            <T value={getLabel()} />
        </Value>
    </Container>
};